(() => {
  // Only run on product pages
  if (!document.documentElement.classList.contains("template-product")) return;

  // Don't override intentional anchors like #reviews, #faq, etc.
  if (window.location.hash) return;

  // Optional: if you use ?variant= links, we still allow the fix
  // but we avoid doing it repeatedly during navigation.
  const KEY = "mm_bundlesuite_scroll_fixed";
  if (sessionStorage.getItem(KEY) === "1") return;

  // Try a few likely selectors BundleSuite might inject.
  const selectors = [
    "[data-bundlesuite]",
    ".bundlesuite",
    ".bundlesuite-bundle",
    ".bs-bundle",
    "#bundlesuite",
    "[id*='bundlesuite']"
  ];

  const hasBundleSuiteUI = () => selectors.some((s) => document.querySelector(s));

  const resetScroll = () => {
    // If some element was auto-focused, the browser may scroll to it.
    if (document.activeElement && document.activeElement !== document.body) {
      try { document.activeElement.blur(); } catch (e) {}
    }

    // Only correct if we actually got pushed down.
    if (window.scrollY > 40) {
      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
      sessionStorage.setItem(KEY, "1");
    }
  };

  // BundleSuite often injects after initial render → wait a bit and retry.
  const attempts = [50, 250, 600, 1000];

  attempts.forEach((ms) => {
    setTimeout(() => {
      if (hasBundleSuiteUI()) resetScroll();
    }, ms);
  });

  // Safety: if the user navigates away/back, allow again.
  window.addEventListener("pagehide", () => sessionStorage.removeItem(KEY));
})();
